// extracted by mini-css-extract-plugin
export default {"error":"Propietarios_error__xMiOs","searchForm":"Propietarios_searchForm__YS2vb","icon":"Propietarios_icon__X41X7"};